module.exports = __webpack_public_path__ + "img/icon_enjoy.dd1eb784.svg";